export default __webpack_public_path__ + "7175f81.png";